document.addEventListener('DOMContentLoaded', () => {
    const toc = document.querySelector('[data-offer-toc]');
    const offerPage = document.querySelector('.offer-page');

    if (!toc || !offerPage) {
        return;
    }

    const headings = Array.from(offerPage.querySelectorAll('.offer-section'))
        .map((section) => section.querySelector('h1, h2, h3, h4, h5, h6'))
        .filter((heading) => heading && heading.textContent.trim());

    if (headings.length === 0) {
        return;
    }

    const list = toc.querySelector('.offer-toc__list');
    const panel = toc.querySelector('.offer-toc__panel');
    const toggle = toc.querySelector('.offer-toc__toggle');

    headings.forEach((heading, index) => {
        let headingId = heading.id;

        if (!headingId || document.getElementById(headingId) !== heading) {
            const baseId = headingId || `offer-toc-${index + 1}`;
            headingId = baseId;
            let suffix = 2;

            while (document.getElementById(headingId)) {
                headingId = `${baseId}-${suffix}`;
                suffix += 1;
            }

            heading.id = headingId;
        }

        const item = document.createElement('li');
        item.className = 'offer-toc__item';

        const link = document.createElement('a');
        link.className = 'offer-toc__link';
        link.href = `#${headingId}`;
        link.textContent = heading.textContent.replace(/\s+/g, ' ').trim();
        link.addEventListener('click', () => {
            panel.hidden = true;
            toggle.setAttribute('aria-expanded', 'false');
        });

        item.append(link);
        list.append(item);
    });

    toc.hidden = false;

    const header = document.querySelector('.header');
    const desktopQuery = window.matchMedia('(min-width: 993px)');

    const syncTocPosition = () => {
        if (!desktopQuery.matches) {
            toc.style.top = '';
            return;
        }

        if (!header) {
            toc.style.top = '16px';
            return;
        }

        const headerRect = header.getBoundingClientRect();
        const headerHidden = header.classList.contains('header--unpinned') || headerRect.bottom <= 0;
        toc.style.top = headerHidden ? '16px' : `${Math.round(headerRect.bottom)}px`;
    };

    syncTocPosition();
    window.addEventListener('scroll', syncTocPosition, { passive: true });
    window.addEventListener('resize', syncTocPosition);

    if (typeof desktopQuery.addEventListener === 'function') {
        desktopQuery.addEventListener('change', syncTocPosition);
    }

    if (header && 'ResizeObserver' in window) {
        new ResizeObserver(syncTocPosition).observe(header);
    }

    if (header && 'MutationObserver' in window) {
        new MutationObserver(syncTocPosition).observe(header, {
            attributes: true,
            attributeFilter: ['class', 'style'],
        });
    }

    const closeToc = () => {
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
    };

    toggle.addEventListener('click', () => {
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isExpanded));
        panel.hidden = isExpanded;
    });

    document.addEventListener('click', (event) => {
        if (panel.hidden || toc.contains(event.target)) {
            return;
        }

        closeToc();
    });

    toc.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !panel.hidden) {
            closeToc();
            toggle.focus();
        }
    });
});
